import React, { Component } from "react";
import Helmet from "react-helmet";
import "./about.scss";

class AboutPage extends Component {
  render() {
    return (
      <div className="about-container">
        <Helmet title={`Datasert - About Us`} />

        <div className="content">
          <h2>About Datasert</h2>
          <p>
            Started in 2010 as "Real Force Explorer", the Salesforce data
            management tool "Realfire" has grown to what it is today, with
            intent of providing seamless and efficient solution for Salesforce
            ecosystem.
          </p>
          <p>
            Datasert Inc was founded to take Realfire to next level and also to
            bring other Salesforce products to solve real business problems.
          </p>
          <p>
            Have something in mind or have question about company or our
            products? We'd love to hear from you. Please get in touch with{" "}
            <a href="./contact">us</a>.
          </p>
        </div>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/company/about.jsx